import Controller, { OnChange, OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../BaseController';
import { Inject } from '@odinjs/odin';
import { Endpoint } from '../../../constants/endpoints';
import { HttpService, } from '@philips-internal/oswald-ui-core/lib/services';
import ShowToast from '../../../utils/toast-service';
import { ToastLevel } from '@philips-internal/oswald-ui-constants';

import { CheckboxAPI, FieldAPI, ModalAPI, ModalService, PanelAPI, TextAPI } from '@philips-internal/oswald-ui-components';
import {CustomDynamicButtonAPI} from '@philips-emr/health-professional-components/src/components';
import { CLINICAL_NOTES_MSG_COOKIE_KEY, ClinicalNotesMsgStatus } from '../clinical-note-service-constants';
import { ClinicalNotesAutoStandardTextAliases, FragmentNames } from '../../../codegen';
import { Value } from '@philips-internal/oswald-ui-core';
import { StandardText } from '../clinical-notes-types';

@Controller({ component: ClinicalNotesAutoStandardTextAliases.LAYOUT_STANDARD_TEXT, fragment: FragmentNames.CLINICAL_NOTES_AUTO_STANDARD_TEXT })
class ClinicalNotesAutoStandardTextController extends BaseController {

  nrTextoPadrao = 0;
  nrSeqGrupo = 0;
  dsTextoReplaced = '';

  @Inject(ClinicalNotesAutoStandardTextAliases.PANEL_LOADER)
    panelLoaderAPI!: PanelAPI;

  @Inject(ClinicalNotesAutoStandardTextAliases.PANEL_ACCEPT)
    panelAcceptAPI!: PanelAPI;

  @Inject(ClinicalNotesAutoStandardTextAliases.MODAL_STANDARD_TEXT)
    modalTextAPI!: ModalAPI;

  @Inject(ClinicalNotesAutoStandardTextAliases.TEXT_MESSAGE)
    textMessageAPI!: TextAPI;

  @Inject(ClinicalNotesAutoStandardTextAliases.ACCEPT_CUSTOM_DYNAMIC_BUTTON)
    acceptCustomDynamicButtonAPI!: CustomDynamicButtonAPI;

  @Inject(ClinicalNotesAutoStandardTextAliases.CHECKBOX_CLICNICAL_NOTES_MSG)
    checkboxAPI!: CheckboxAPI;

  @Inject(ClinicalNotesAutoStandardTextAliases.FIELD_CLICNICAL_NOTES_MSG)
    checkboxFieldAPI!: FieldAPI;

  showActionsLoadText(visible: boolean): void {
    this.panelLoaderAPI.setVisible(!visible);
    this.panelAcceptAPI.setVisible(!visible);
  }

  showActionsAccept(visible: boolean): void {
    this.panelLoaderAPI.setVisible(!visible);
    this.panelAcceptAPI.setVisible(visible);
  }

  close(): void {
    ModalService.close('clinical-notes-auto-standard-text');
  }

  getClinicalNotesMsgCookieValue(): string | undefined {
    const clinicalNotesMsgCookie = document.cookie.split(';').find(cookie => cookie.match(CLINICAL_NOTES_MSG_COOKIE_KEY));
    const clinicalNotesMsgCookieValue = clinicalNotesMsgCookie?.split('=')[1];
    return clinicalNotesMsgCookieValue;
  }

  dispatchAddStandardTextEvent(): void {
    const event = new CustomEvent('addStandardText', { detail: this.dsTextoReplaced });
    dispatchEvent(event);
  }

  @OnChange(ClinicalNotesAutoStandardTextAliases.CHECKBOX_CLICNICAL_NOTES_MSG)
  onChangeCheckBox(): void {
    this.checkboxAPI.setValue(!this.checkboxAPI.getValue())
  }

  @OnMount(ClinicalNotesAutoStandardTextAliases.LAYOUT_STANDARD_TEXT)
  onMount(): void {

    const { encounterId: nrAtendimento, patientId: cdPessoaFisica } = this.historyService.getCurrentRouteParams();
    const nrTextoPadrao = this.context.get('nrTextoPadrao');

    const standardTextType = 'INSTITUTION';

    this.panelLoaderAPI.setVisible(true);
    this.textMessageAPI.setValue('label.load-message-standard');
    this.showActionsAccept(false);

    const showClinicalNotesMsg = !(this.getClinicalNotesMsgCookieValue() === ClinicalNotesMsgStatus.DEACTIVATED);
    const params = { cdPessoaFisica, nrAtendimento, nrTextoPadrao, standardTextType } as Record<string, Value>

    HttpService.get<StandardText>(
      Endpoint.GET_NOTAS_CLINICAS_STANDARD_TEXT,
      params
    ).then(response => {
      const body = response.body as StandardText;
      this.dsTextoReplaced = body.dsTexto;
      this.showActionsAccept(true);
      this.textMessageAPI.setValue('text.not-change- in-standard-text');

      if (!showClinicalNotesMsg) {
        this.dispatchAddStandardTextEvent();
        this.close();
      }
    }).catch(err => {
      this.showActionsLoadText(true);
      ShowToast.open(err?.body.errorMessage, ToastLevel.ERROR);
      this.close();
    });
  }

  @OnClick(ClinicalNotesAutoStandardTextAliases.ACCEPT_CUSTOM_DYNAMIC_BUTTON)
  onButtonAcceptClick(): void {
    this.handleAcceptClick();
  }

  handleCancelClick(): void {
    this.close();
  }

  handleAcceptClick(): void {
    if (this.checkboxAPI.getValue()) {
      document.cookie = `${CLINICAL_NOTES_MSG_COOKIE_KEY}=${ClinicalNotesMsgStatus.DEACTIVATED}`;
    }

    this.dispatchAddStandardTextEvent();

    this.close();
  }
}

export default ClinicalNotesAutoStandardTextController;
